import React from 'react';

interface SteamIconProps {
  className?: string;
}

const SteamIcon: React.FC<SteamIconProps> = ({ className = "w-5 h-5" }) => {
  return (
    <img
      src="/logos/steam-logo.webp"
      alt="Steam Logo"
      className={className}
      style={{ display: 'inline', verticalAlign: 'middle' }}
    />
  );
};

export default SteamIcon; 